import { getErrorDescription } from '../../errors';

export function isModalError(error) {
  if (!error) return false;

  const { modal = true } = getErrorDescription(error);

  return modal;
}
